/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: RjYJ6AJe84Rc

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawTh } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawTable/Th"; // plasmic-import: jsU1J_F6J87o/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicTableTh.module.css"; // plasmic-import: RjYJ6AJe84Rc/css

createPlasmicElementProxy;

export type PlasmicTableTh__VariantMembers = {};
export type PlasmicTableTh__VariantsArgs = {};
type VariantPropType = keyof PlasmicTableTh__VariantsArgs;
export const PlasmicTableTh__VariantProps = new Array<VariantPropType>();

export type PlasmicTableTh__ArgsType = {
  colSpan?: number;
  rowSpan?: number;
  alternateBackground?: boolean;
  verticalAlign?: string;
  hidden?: boolean;
  background?: string;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicTableTh__ArgsType;
export const PlasmicTableTh__ArgProps = new Array<ArgPropType>(
  "colSpan",
  "rowSpan",
  "alternateBackground",
  "verticalAlign",
  "hidden",
  "background",
  "children"
);

export type PlasmicTableTh__OverridesType = {
  root?: Flex__<typeof RawTh>;
};

export interface DefaultTableThProps {
  colSpan?: number;
  rowSpan?: number;
  alternateBackground?: boolean;
  verticalAlign?: string;
  hidden?: boolean;
  background?: string;
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTableTh__RenderFunc(props: {
  variants: PlasmicTableTh__VariantsArgs;
  args: PlasmicTableTh__ArgsType;
  overrides: PlasmicTableTh__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          colSpan: 1,
          rowSpan: 1,
          alternateBackground: false,
          verticalAlign: "middle",
          hidden: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    (() => {
      try {
        return !$props.hidden;
      } catch (e) {
        if (
          e instanceof TypeError ||
          e?.plasmicType === "PlasmicUndefinedDataError"
        ) {
          return true;
        }
        throw e;
      }
    })() ? (
      <RawTh
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "__wab_instance",
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.root
        )}
        colSpan={args.colSpan}
        rowSpan={args.rowSpan}
        style={(() => {
          try {
            return {
              background:
                $props.background ||
                ($props.alternateBackground ? "#003A74" : undefined),
              verticalAlign: $props.verticalAlign,
              wordWrap: "break-word",
              hyphens: "auto"
            };
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
      >
        {renderPlasmicSlot({
          defaultContents: "Header",
          value: args.children,
          className: classNames(sty.slotTargetChildren)
        })}
      </RawTh>
    ) : null
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof RawTh;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTableTh__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTableTh__VariantsArgs;
    args?: PlasmicTableTh__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicTableTh__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicTableTh__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTableTh__ArgProps,
          internalVariantPropNames: PlasmicTableTh__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTableTh__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTableTh";
  } else {
    func.displayName = `PlasmicTableTh.${nodeName}`;
  }
  return func;
}

export const PlasmicTableTh = Object.assign(
  // Top-level PlasmicTableTh renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicTableTh
    internalVariantProps: PlasmicTableTh__VariantProps,
    internalArgProps: PlasmicTableTh__ArgProps
  }
);

export default PlasmicTableTh;
/* prettier-ignore-end */
